import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 设施类型管理API服务
 */
export const deviceTypeService = {
  // ==================== 消防系统（一级分类）相关接口 ====================

  /**
   * 获取消防系统列表
   */
  listFireSystems: () => axios.get(`${iffApi}/deviceType/system/list`, { params: {} }),

  /**
   * 保存消防系统
   * @param {Object} data 系统信息
   */
  saveFireSystem: (data) => axios.post(`${iffApi}/deviceType/system/save`, data),

  /**
   * 删除消防系统
   * @param {String} uuid 系统ID
   */
  deleteFireSystem: (uuid) => axios.delete(`${iffApi}/deviceType/system/delete/${uuid}`),

  /**
   * 切换消防系统状态
   * @param {String} uuid 系统ID
   * @param {Number} status 目标状态
   */
  toggleFireSystemStatus: (uuid, status) => axios.post(`${iffApi}/deviceType/system/toggleStatus`, null, { params: { uuid, status } }),

  // ==================== 设施类型（二级分类）相关接口 ====================

  /**
   * 获取设施类型列表
   * @param {String} systemId 消防系统ID（可选）
   */
  listDeviceTypes: (systemId) => {
    const params = {};
    if (systemId) params.systemId = systemId;
    return axios.get(`${iffApi}/deviceType/type/list`, { params });
  },

  /**
   * 保存设施类型
   * @param {Object} data 类型信息
   */
  saveDeviceType: (data) => axios.post(`${iffApi}/deviceType/type/save`, data),

  /**
   * 删除设施类型
   * @param {String} uuid 类型ID
   */
  deleteDeviceType: (uuid) => axios.delete(`${iffApi}/deviceType/type/delete/${uuid}`),

  /**
   * 切换设施类型状态
   * @param {String} uuid 类型ID
   * @param {Number} status 目标状态
   */
  toggleDeviceTypeStatus: (uuid, status) => axios.post(`${iffApi}/deviceType/type/toggleStatus`, null, { params: { uuid, status } })
};
